import React from "react"
import { modalStyle } from "constants/layout"

import { Modal, Box } from "@mui/material"
import { AiOutlineClose } from "react-icons/ai"
import { Button } from "reactstrap"
import useWindowsSize from "hooks/useWindowsSize"

const MaterialModal = ({
  modal,
  iconHeader,
  toggle,
  modalHeader,
  deleteDoc,
  customStyles,
  handleSubmit,
  handleDelete,
  children,
  edit,
  disableOutside,
  submitDisabled,
}) => {
  const { isMobile } = useWindowsSize()

  const modalStyles = {
    ...modalStyle,
    width: isMobile ? "90%" : modalStyle.width,
  }

  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick" && disableOutside) {
      return
    }
    toggle()
  }

  return (
    <Modal open={modal} onClose={handleClose}>
      <Box style={customStyles || modalStyles}>
        <div
          className="bg-white p-3 d-flex flex-column"
          style={{ borderRadius: 6 }}
        >
          <div className="d-flex justify-content-between align-items-center">
            <div className="d-flex align-items-center gap-2">
              {iconHeader}
              <p className="mb-0 card-title">{modalHeader}</p>
            </div>
            <Button color="" className="shadow-none p-0" onClick={toggle}>
              <AiOutlineClose size={16} />
            </Button>
          </div>
          {children}
          {handleSubmit && (
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button
                color={deleteDoc ? "danger" : "primary"}
                className="shadow-none mt-1"
                onClick={deleteDoc ? handleDelete : handleSubmit}
                disabled={!deleteDoc && submitDisabled}
              >
                {deleteDoc ? "Eliminar" : edit ? "Grabar" : "Agregar"}
              </Button>
              <Button
                color="light"
                className="shadow-none mt-1"
                onClick={toggle}
              >
                Cancelar
              </Button>
            </div>
          )}
        </div>
      </Box>
    </Modal>
  )
}

export default MaterialModal
